import { api } from '../../lib/api.js'
import { Card, Empty, ErrorBox, Page, Spinner, useAsync } from '../../components/Ui.jsx'

export default function Farmers () {
  const { data, error, loading, reload } = useAsync(() => api.get('/admin/farmers'), [], { live: ['farmers'] })

  if (loading) return <Page title="Farmers"><Spinner /></Page>
  if (error) return <Page title="Farmers"><ErrorBox error={error} onRetry={reload} /></Page>

  return (
    <Page
      title="Farmers"
      subtitle="Farmers do not sign in. The operator desk books on their behalf over the phone, so this is the book of pond locations and water conditions the desk matches against."
    >
      <Card padded={false}>
        <div className="scroll-x">
          <table>
            <thead>
              <tr>
                <th>Farmer</th><th>Phone</th><th>Pond location</th>
                <th className="num">Pond salinity</th><th className="num">Area</th><th className="num">Bookings</th>
              </tr>
            </thead>
            <tbody>
              {data.farmers.map(f => (
                <tr key={f._id}>
                  <td><b>{f.name}</b></td>
                  <td className="mono small">{f.phone}</td>
                  <td>{f.place}<span className="t-sub mono">{f.lat}, {f.lng}</span></td>
                  <td className="num">{f.pondSalinityPpt ?? '—'} ppt</td>
                  <td className="num">{f.pondAreaAcres ?? '—'} ac</td>
                  <td className="num">{f.ordersCount}</td>
                </tr>
              ))}
              {!data.farmers.length && <tr><td colSpan={6}><Empty>No farmers on file yet.</Empty></td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </Page>
  )
}
